import React from 'react';
import PropTypes from 'prop-types';

import CertsUserListDropdown from '../../CertsUserListDropdown';

import './BulkActionConsult.css';

function BulkActionConsultList({
  isSubmitting,
  isCritical,
  consultWith,
  setBulkActionConsult,
  certKey,
  defaultReassignee,
  defaultAssigneName,
  placeholder,
  certifierUserKey,
}) {
  const handleAssigneeChange = (selectedOption) => {
    let consultWithName = '';

    if (selectedOption?.username?.trim()?.length !== 0) {
      consultWithName = selectedOption?.username;
    } else {
      consultWithName = `${selectedOption?.firstname} ${selectedOption?.lastname}`;
    }

    setBulkActionConsult((prev) => ({
      ...prev,
      consultWith: selectedOption?.value || '',
      consultWithName,
    }));
  };

  return (
    <CertsUserListDropdown
      defaultReassignee={defaultReassignee}
      defaultAssigneName={defaultAssigneName}
      onSelect={handleAssigneeChange}
      isCritical={isCritical}
      isDisabled={isSubmitting}
      selectedUser={consultWith?.trim()?.length !== 0}
      certKey={certKey}
      placeholder={placeholder}
      certifierUserKey={certifierUserKey}
    />
  );
}

BulkActionConsultList.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  isCritical: PropTypes.bool.isRequired,
  consultWith: PropTypes.string.isRequired,
  setBulkActionConsult: PropTypes.func.isRequired,
  certKey: PropTypes.string.isRequired,
  defaultReassignee: PropTypes.string.isRequired,
  defaultAssigneName: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  certifierUserKey: PropTypes.string.isRequired,
};

export default React.memo(BulkActionConsultList);
